import { render } from "./LbrxLanguageSelectPopup.vue?vue&type=template&id=7f7812ea&scoped=true"
import script from "./LbrxLanguageSelectPopup.vue?vue&type=script&lang=js"
export * from "./LbrxLanguageSelectPopup.vue?vue&type=script&lang=js"

import "./LbrxLanguageSelectPopup.vue?vue&type=style&index=0&id=7f7812ea&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f7812ea"]])

export default __exports__